import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
  isDevMode,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr, ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HttpErrorInterceptor } from '../network/http-error.interceptor';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import {
  NgHttpLoaderModule,
  pendingRequestsInterceptor$,
} from 'ng-http-loader';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([pendingRequestsInterceptor$])
    ),
    // importProvidersFrom(NgHttpLoaderModule.forRoot()),
    BsDatepickerConfig,
    JwtHelperService,
    BsDropdownConfig,
    provideAnimations(),
    provideToastr({
      timeOut: 1000,
      positionClass: 'toast-top-center',
    }),
    BsModalService,
    ToastrService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    environment.production ? provideServiceWorker('ngsw-worker.js') : [],
  ],
};
